import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import { PRIMARY } from '../theme/theme';

const TermsOfService: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Paper elevation={0} sx={{ p: 4, border: '1px solid rgba(0, 0, 0, 0.08)', borderRadius: 2 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: PRIMARY, fontWeight: 700 }}>
            Terms of Service
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3, fontWeight: 600 }}>
            BLUEBERRYBYTES SERVICES FZCO
          </Typography>
          
          <Typography variant="body2" paragraph sx={{ mb: 3 }}>
            Last updated: April 17, 2025
          </Typography>
          
          <Divider sx={{ mb: 3 }} />
          
          <Typography variant="body1" paragraph>
            Welcome to the MicroLearning App. Please read these Terms of Service ("Terms") carefully before using our mobile application (the "Service") operated by BLUEBERRYBYTES SERVICES FZCO ("we", "us", or "our").
          </Typography>
          
          <Typography variant="body1" paragraph>
            By downloading, accessing, or using our Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            1. Use of the Service
          </Typography>
          
          <Typography variant="body1" paragraph>
            The MicroLearning App is designed to provide educational content in bite-sized formats. You may use our Service only for lawful purposes and in accordance with these Terms. You agree not to use the Service:
          </Typography>
          
          <Typography variant="body1" component="ul" sx={{ pl: 4, mb: 2 }}>
            <li>In any way that violates any applicable national or international law or regulation.</li>
            <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail", "chain letter", or "spam".</li>
            <li>To impersonate or attempt to impersonate the Company, a Company employee, another user, or any other person or entity.</li>
            <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Service.</li>
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            2. Intellectual Property
          </Typography>
          
          <Typography variant="body1" paragraph>
            The Service and its original content, features, and functionality are and will remain the exclusive property of BLUEBERRYBYTES SERVICES FZCO and its licensors. The Service is protected by copyright, trademark, and other laws of both the United Arab Emirates and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of BLUEBERRYBYTES SERVICES FZCO.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            3. User Accounts
          </Typography>
          
          <Typography variant="body1" paragraph>
            When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.
          </Typography>
          
          <Typography variant="body1" paragraph>
            You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password. You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            4. Subscription and Payments
          </Typography>
          
          <Typography variant="body1" paragraph>
            Some parts of the Service are offered on a subscription basis. You will be billed in advance on a recurring basis, depending on the subscription plan you select. Subscription fees are non-refundable except as required by law or as explicitly stated in our refund policy.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            5. Termination
          </Typography>
          
          <Typography variant="body1" paragraph>
            We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            6. Limitation of Liability
          </Typography>
          
          <Typography variant="body1" paragraph>
            In no event shall BLUEBERRYBYTES SERVICES FZCO, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            7. Changes to Terms
          </Typography>
          
          <Typography variant="body1" paragraph>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            8. Contact Us
          </Typography>
          
          <Typography variant="body1" paragraph>
            If you have any questions about these Terms, please contact us at support@blueberrybytes.com.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default TermsOfService;
